<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-row flex-grow-1">
            <div style="width:16px"></div>
            <ul class="nav nav-pills" style="row-gap: 8px;">
                <li class="nav-item-scv nav-item">
                    <a href="#prohibit" class="nav-link-scv nav-link active" data-bs-toggle="tab" @click="openProhibitApp">禁止するアプリケーション（ブラックリスト）</a>
                </li>
                <li class="nav-item-scv nav-item">
                    <a href="#noProhibit" class="nav-link-scv nav-link" data-bs-toggle="tab" @click="openNoProhibitApp">許可アプリケーションに関する利用設定</a>
                </li>
            </ul>
        </div>

        <div style="height:16px"></div>

        <div class="d-flex flex-column flex-grow-1 tab-content">
            <div id="prohibit" class="tab-pane show-tab-content-flex-grow">
                <div style="margin: 0px 0px 12px 16px;">
                    利用を禁止するアプリケーションを登録してください。
                </div>

                <ListTitleBar :titleCaption="'利用を禁止するアプリケーション（ブラックリスト）'"
                              :btnCaption_1="'追加'"
                              :btnCaption_2="'削除'"
                              :btnActiveType_1="0"
                              :btnActiveType_2="3"
                              :rowCountArea="true"
                              :rowCount="getRowCount()"
                              :enableSearchText="true"
                              @onSearchBoxKeydown="onSearchBoxKeydownForProhibit"
                              @onBtnClear="onBtnClearForProhibit"
                              @onBtnClicked_1="onBtnAddProhibitApp"
                              @onBtnClicked_2="onBtnDelProhibitApp"
                              :selectCount="getSelectCountForProhibit()"
                              v-bind:disabled="!isCheckMobileAndroid">
                </ListTitleBar>
                <ListCtrl ref="prohibitList"
                          :columns="prohibitColumns"
                          :getCellTextFunc="getCellTextProhibitList"
                          :getCellHTMLFunc="getCellHTMLProhibitList"
                          :selectType="2"
                          @onClickCell="onClickCell"
                          style="min-height: 320px; max-height: 320px;">
                </ListCtrl>
            </div>

            <div id="noProhibit" class="tab-pane">
                <div style="margin: 0px 0px 12px 16px;">
                    利用を許可する（ブラックリストに登録されていない）アプリケーションは、インストール種別等の利用設定が可能です。
                </div>
                <AppMgrPermissionAppList v-model="listWhiteSetting"
                                         listTitle="利用設定するアプリケーション"
                                         idName="blwl"
                                         :mode=1
                                         :getURLFunction="getURLFunction"
                                         :getAppFunction="getAppFunction"
                                         :getBlackPackageNameList="getBlackPackageNameList" 
                                         @notifyUpdate ="OnNotifyUpdate"
                                         @notifyMDMApp ="OnNotifyMDMApp"
                                         :isCheckMobileAndroid ="!isCheckMobileAndroid"
                                         :mdmAppPackageName="mdmAppPackageName"
                                         :enableAddMDMApp="enableAddMDMApp"
                                         :getUntrustedAppsPolicyFunction="getUntrustedAppsPolicyFunction"
                                         :version="version"/>

                <div class="d-flex flex-row align-items-center" style="margin-bottom: 8px; margin-top: 24px;">
                    <img src="@/assets/img/guide_info_color.svg" height="24" style="margin-right: 8px" />
                    <span>本リストに登録されないアプリケーションは、以下の設定で利用できます。</span>
                </div>


                <div class="table-scv-out-border" style=" width: 659px; ">
                    <div class="d-flex flex-column table-div-scv">
                        <div class="thead-div-scv">
                            <div class="d-flex flex-row tr-div-scv">
                                <div class="th-div-scv" style=" min-width: 256px; ">設定項目</div>
                                <div class="th-div-scv" style=" min-width: 400px; ">設定内容</div>
                            </div>
                        </div>

                        <div class="tbody-div-scv">
                            <div class="tr-div-scv">
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 256px; ">インストール種別</div>
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 400px; ">任意インストール</div>
                            </div>
                            <div class="tr-div-scv">
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 256px; ">自動アップデート種別</div>
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 400px; ">標準アップデート（※）</div>
                            </div>
                            <div class="tr-div-scv">
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 256px; ">アクセス権限の許可設定</div>
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 400px; ">端末利用者が設定</div>
                            </div>
                            <div class="tr-div-scv">
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 256px; ">アプリケーション管理設定</div>
                                <div class="td-div-scv scv-info-manual-setting-mobile-app-distribution-cell" style=" min-width: 400px; ">設定なし</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tooltip-manual-body-scv-padding-height-4"></div>
                <div class="scv-annotation-text">
                    （※）Android標準のアップデート設定です。<br />
                    端末の設定に従って、アプリケーションをアップデートします。
                </div>

            </div>
        </div>

        <!-- Playストアから選択画面  -->
        <AndroidGooglePlayDialog ref="androidGooglePlayDialog"
                                 @onOk="onApplicationSelected"
                                 idName="blbl"
                                 :getURLFunction="getURLFunction"
                                 :getAppFunction="getAppFunction"
                                 :blackPackageList="blackPackageList"
                                 :whitePackageList="whitePackageList" 
                                 :isBlackConfigList="true"/>

        <!-- アプリ詳細画面  -->
        <AppMgrApplicationDetailModal ref="detailModal" />
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import { cloneDeep } from 'lodash';
    import { ListCtrl } from 'lib-vue-v2/components';
    import ListTitleBar from '@/components/ListTitleBar.vue';
    import { SearchColumnData, SearchColumnType } from '@/models/SearchColumnData';
    import { AndroidAppMgrDef } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrDef';
    import { AndroidAppMgrApplicationSetting, AndroidAppMgrApplicationBasicJson } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrApplicationSetting';
    import AppMgrPermissionAppList from '@/components/Mobile/AndroidAppDist/AppMgrPermissionAppList.vue'
    import { ApplicationPolicyConverter, ApplicationPolicyDef } from '@/models/Mobile/AndroidAppDist/ApplicationPolicyConverter'
    import AppMgrApplicationDetailModal from '@/components/Mobile/AndroidAppDist/AppMgrApplicationDetailModal.vue';
    import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper'
    import { AndroidAppDistDefinition } from "@/components/Mobile/AndroidAppDist/AndroidAppDistDefinition";

    // for AndroidGooglePlayDialog
    import AndroidGooglePlayDialog from '@/views/Mobile/Popup/AndroidGooglePlayDialog.vue';
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
    import { MessageUtil } from "@/models/Message/MessageUtil";
    import { AndroidApplicationWrapper } from '@/models/Mobile/Android/AndroidApplicationWrapper'
    import { BootstrapUtil } from "lib-vue-v2/util";

    @Options({
        props: {
            getURLFunction: { type: Function },     // Google Play を iframe に埋め込むためのURL取得関数
            getAppFunction: { type: Function },      // アプリケーション詳細情報の取得関数
            isCheckMobileAndroid: { type: Boolean, default: false }, // AndroidライセンスがONかどうか
            getUntrustedAppsPolicyFunction: { type: Function }      // 提供元不明のアプリケーションのインストール
        },
        components: {
            ListCtrl,
            ListTitleBar,
            AndroidGooglePlayDialog,
            AppMgrPermissionAppList,
            AppMgrApplicationDetailModal
        },
        emits: ['notifyUpdate'],
        watch: {
            blackListProhibitSetting: {
                handler: function () {
                    /* eslint @typescript-eslint/no-explicit-any: 0 */
                    const refObj: any = this.$refs;
                    refObj.prohibitList.updateList(this.blackListProhibitSetting.length);
                },
                deep: true,   // オブジェクトの監視
                immediate: false
            },
        },
    })

    export default class AppMgrBlackListSettingForAndroid extends Vue {
        // 定義値
        private def = new AndroidAppMgrDef();

        // ポリシー⇔UIデータ
        private converter = new ApplicationPolicyConverter();

        // リスト関連（禁止するアプリケーション（ブラックリスト））
        private blackListProhibitSetting = new Array<AndroidAppMgrApplicationSetting>();
        private readonly prohibitColumns: Array<SearchColumnData> =         // カラム
            [
                { columnID: 2, dataType: SearchColumnType.icon, text: "" },
                { columnID: 0, dataType: SearchColumnType.string | SearchColumnType.link, text: "アプリケーション名" },
                { columnID: 1, dataType: SearchColumnType.string, text: "パッケージ名" },
            ];

        // リスト関連（禁止しないアプリケーションの個別設定）
        private listWhiteSetting = new Array<AndroidAppMgrApplicationSetting>();

        // 現在登録済みのアプリケーション（重複チェック用）
        private blackPackageList: Set<string> = new Set<string>();
        private whitePackageList: Set<string> = new Set<string>();
        
        // MDMアプリ情報
        private mdmAppPackageName = ""; // MDMアプリのパッケージ名
        private isMDMAppInstall = 0;    // MDMアプリのインストール設定
        private enableAddMDMApp = true; // MDMアプリの追加を表示させるか
        private version = 0

        /**
         * MDMアプリが追加されたかどうか
         */
        private OnNotifyMDMApp(isMDM: boolean): void {
            if (2 == this.isMDMAppInstall) {
                this.enableAddMDMApp = !isMDM;
            }
        }

        /**
         * @brief	設定変更時
         * @return	なし
         */
        public OnNotifyUpdate(): void {
            this.$emit("notifyUpdate");
        }

        /**
         * UIデータの初期化
         */
        public InitData(editPolicy: AndroidPolicyWrapper): void {
            this.blackListProhibitSetting = new Array<AndroidAppMgrApplicationSetting>();
            this.blackPackageList = new Set<string>();
            this.listWhiteSetting = new Array<AndroidAppMgrApplicationSetting>();
            this.whitePackageList = new Set<string>();

            // オンプレが過去管理機の場合を考慮して一旦初期値を設定
            this.isMDMAppInstall = 0;
            this.mdmAppPackageName = "";
            this.enableAddMDMApp = false;
            this.version = 0;

            if (undefined != editPolicy.skypolicy.skyAppInfo) {
                this.mdmAppPackageName = editPolicy.skypolicy.skyAppInfo.mdmAppInfo.packageName;
            }
            if (undefined != editPolicy.skypolicy.settingInfo) {
                this.isMDMAppInstall = editPolicy.skypolicy.settingInfo.mdmAppInstallType;
            }
            if (undefined != editPolicy.skypolicy.version) {
                this.version = editPolicy.skypolicy.version;
            }

            // 手動でインストールかどうかで初期値を設定
            if (2 == this.isMDMAppInstall) {
                this.enableAddMDMApp = true;
            }
            else {
                this.enableAddMDMApp = false;
            }
        }

        /**
         * UIデータの反映
         */
        public LoadUIData(editPolicy: AndroidPolicyWrapper): void {
            this.InitData(editPolicy);
            if (undefined == editPolicy.policy.applications) {
                return;
            }

            // 基本情報の取得が必要なパッケージ
            const packageNames = new Array<string>();
            // 基本情報を紐づけしやすいようにMapにも記憶
            const packageMap = new Map<string, AndroidAppMgrApplicationSetting>();

            // ポリシー情報割り当て
            for (const policy of editPolicy.policy.applications) {
                const setting = new AndroidAppMgrApplicationSetting();
                setting.policyJson = policy;
                setting.basicInfo.packageName = this.converter.GetPackageName(setting.policyJson);  // 基本情報が取れていないとbasicInfoにパッケージIDがない状態になり、色々と都合が悪いのでここで保管しておく
                setting.basicInfo.appSettingType = AndroidAppDistDefinition.APP_SETTING_TYPE_GOOGLE_PLAY;
                                
                if (ApplicationPolicyDef.DISTRIBUTION_TYPE.Black == this.converter.GetDistributionType(setting.policyJson)) {
                    // 禁止アプリ
                    this.blackListProhibitSetting.push(setting);
                }
                else {
                    // 許可アプリ
                    this.listWhiteSetting.push(setting);
                    
                    // 手動でインストールかつ、MDMアプリが登録されてる
                    if (2 == this.isMDMAppInstall && this.mdmAppPackageName == setting.policyJson.packageName) {
                        this.enableAddMDMApp = false;
                    }
                }

                packageNames.push(this.converter.GetPackageName(setting.policyJson));
                packageMap.set(this.converter.GetPackageName(setting.policyJson), setting);
            }

            // 基本情報の割り当て
            if (undefined != editPolicy.skypolicy.applicationInfo) {
                for (let i = 0; i < editPolicy.skypolicy.applicationInfo.length; i++) {
                    const setting = packageMap.get(editPolicy.skypolicy.applicationInfo[i].packageName);
                    if (undefined == setting) {
                        continue;
                    }

                    // 基本情報の更新
                    setting.basicInfo = {
                        appSettingType:AndroidAppDistDefinition.APP_SETTING_TYPE_GOOGLE_PLAY,
                        ...cloneDeep(editPolicy.skypolicy.applicationInfo[i])
                    }
                    // 基本情報の更新日時はundefinedにする。更新されたデータだけ送信したいので。
                    setting.basicInfo.updateTimeUtc = undefined;
                }
            }
        }

        /**
         * UIデータの吸い上げ
         */
        public SaveUIData(editPolicy: AndroidPolicyWrapper): void {
            editPolicy.policy.applications = new Array<schema.AMAPI_ApplicationPolicyExtend>();

            let bCreateApplicationInfo = false;
            if (undefined == editPolicy.skypolicy.applicationInfo) {
                editPolicy.skypolicy.applicationInfo = new Array<AndroidAppMgrApplicationBasicJson>();
                bCreateApplicationInfo = true;
            }

            // #45289 【M1クラウド（Android端末のMDM対応）】アプリ管理で設定を切り替えた後、Android端末に設定が下りてこない
            // リスト内に同じパッケージが複数あると、設定が適用できないなどの不具合に繋がる
            // ただ、リスト内で重複しているパッケージを作成させる方法がわからなかった。
            // フェールセーフとして、重複チェックを行い先勝ち(禁止優先)で実装する。
            const setDuplication = new Set<string>();
            const arDeleteBLDuplicationIndex = new Array<number>();
            const arDeleteWLDuplicationIndex = new Array<number>();

            // 禁止アプリ
            for (let i = 0; i < this.blackListProhibitSetting.length; i++) {
                const item = this.blackListProhibitSetting[i];
                const lowerPackage = this.converter.GetPackageName(item.policyJson).toLowerCase();

                if (!setDuplication.has(lowerPackage)) {
                    setDuplication.add(lowerPackage);
                    editPolicy.policy.applications.push(item.policyJson);

                    // 更新された基本情報
                    if (undefined != item.basicInfo.updateTimeUtc) {
                        editPolicy.skypolicy.applicationInfo.push(item.basicInfo);
                    }
                }
                else {
                    arDeleteBLDuplicationIndex.push(i);
                }
            }

            // 許可アプリ
            for (let i = 0; i < this.listWhiteSetting.length; i++) {
                const item = this.listWhiteSetting[i];
                const lowerPackage = this.converter.GetPackageName(item.policyJson).toLowerCase();

                if (!setDuplication.has(lowerPackage)) {
                    setDuplication.add(lowerPackage);
                    editPolicy.policy.applications.push(item.policyJson);

                    // 更新された基本情報
                    if (undefined != item.basicInfo.updateTimeUtc) {
                        editPolicy.skypolicy.applicationInfo.push(item.basicInfo);
                    }
                }
                else {
                    arDeleteWLDuplicationIndex.push(i);
                }
            }

            // 重複していたパッケージを削除
            for (let i = arDeleteBLDuplicationIndex.length; 0 < i; i--) {
                this.blackListProhibitSetting.splice(arDeleteBLDuplicationIndex[i - 1], 1);
            }
            for (let i = arDeleteWLDuplicationIndex.length; 0 < i; i--) {
                this.listWhiteSetting.splice(arDeleteWLDuplicationIndex[i - 1], 1);
            }

            if (0 == editPolicy.skypolicy.applicationInfo.length) {
                if (bCreateApplicationInfo) {
                    // applicationInfoはここで作ったものなので削除する
                    editPolicy.skypolicy.applicationInfo = undefined;
                }
            }
        }

        /**
         * @brief	禁止するアプリケーション（ブラックリスト）を開く
         */
        private openProhibitApp(): void {
            const prohibit = document.getElementById('prohibit');
            const noProhibit = document.getElementById('noProhibit');
            if (null == prohibit || null == noProhibit) return;
            prohibit.classList.add("show-tab-content-flex-grow");
            noProhibit.classList.remove("show-tab-content-flex-grow");
        }

        /**
         * @brief	禁止しないアプリケーションの個別設定を開く
         */
        private openNoProhibitApp(): void {
            const blackList = document.getElementById('prohibit');
            const noProhibit = document.getElementById('noProhibit');
            if (null == blackList || null == noProhibit) return;
            blackList.classList.remove("show-tab-content-flex-grow");
            noProhibit.classList.add("show-tab-content-flex-grow");
        }

        /*
         * 選択状態の数を返します
         */
        private getRowCount(): number {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            // マウント前はundefinedの可能性があるのでundefinedチェックが必要
            if (undefined == refObj.prohibitList) {
                return 0;
            }
            return refObj.prohibitList.getDisplayListIndex().length;
        }

        /*
         * 文字検索開始（Enter押下）（禁止するアプリケーション（ブラックリスト））
         */
        private onSearchBoxKeydownForProhibit(searchText: string): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            refObj.prohibitList.search(searchText);
        }

        /*
         * 文字検索終了（解除押下）（禁止するアプリケーション（ブラックリスト））
         */
        private onBtnClearForProhibit(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            refObj.prohibitList.search("");
        }

        /*
         * 選択状態の数を返します（禁止するアプリケーション（ブラックリスト））
         */
        private getSelectCountForProhibit(): number {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            // マウント前はundefinedの可能性があるのでundefinedチェックが必要
            if (undefined == refObj.prohibitList) {
                return 0;
            }
            return refObj.prohibitList.getSelectListIndex().length;
        }

        /**
         * リスト作成処理(禁止するアプリケーション（ブラックリスト）)
         */
        private getCellTextProhibitList(columnId: number, index: number): string {

            if (this.blackListProhibitSetting.length <= index) {
                return "";
            }

            switch (columnId) {
                // パッケージ名
                case 1:
                    return this.converter.GetPackageName(this.blackListProhibitSetting[index].policyJson);
            }
            return "";
        }

        /**
         * リスト作成処理(HTML)
         */
        private getCellHTMLProhibitList(columnId: number, index: number): string {

            if (this.blackListProhibitSetting.length <= index) {
                return "";
            }

            switch (columnId) {
                // アイコン
                case 2:
                    if (0 != this.blackListProhibitSetting[index].basicInfo.iconUrl.length) {
                        return "<div style=\"padding: 8px 0px;\"><img src=\"" + this.blackListProhibitSetting[index].basicInfo.iconUrl + "\" style=\"height: 32px; width: 32px; border-radius: 7px; border: 0.5px solid #E6EBF0\"></div>";
                    }
                    else {
                        return "<div style=\"padding: 8px 0px;\"><div style=\"height: 32px; width: 32px; border-radius: 7px; border: 0.5px solid #E6EBF0\"></div></div>";
                    }

                case 0: // アプリケーション名
                    return "<span class=\"scv-link-text\" style=\"cursor: pointer;\">" + this.blackListProhibitSetting[index].basicInfo.appName + "</span>";
            }
            return "";
        }

        /**
         * セルクリック時の処理
         */
        private onClickCell(columnId: number, index: number) {
            if (this.blackListProhibitSetting.length <= index) {
                return "";
            }

            switch (columnId) {
                // アプリ名（詳細表示）
                case 0:
                    this.displayDetail(this.blackListProhibitSetting[index]);
                    return;
            }
            return "";
        }

        /**
         * 詳細表示
         */
        private displayDetail(data: AndroidAppMgrApplicationSetting) {
            // アプリ詳細画面を表示
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            refObj.detailModal.SetData(data.basicInfo);
            BootstrapUtil.showModal(refObj.detailModal.GetID());
        }

        /**
         * @brief	追加ボタン（禁止するアプリケーション（ブラックリスト））
         */
        private onBtnAddProhibitApp(): void {
            if (this.def.APPLICATION_LIST_MAX_LENGTH <= this.blackListProhibitSetting.length) {
                MessageUtil.MessageBox(
                    "これ以上登録することはできません。<br />利用を禁止するアプリケーション（ブラックリスト）の登録上限は" + this.def.APPLICATION_LIST_MAX_LENGTH + "件です。"
                    , null
                    , null
                    , MessageUtil.MB_ICON_WARNING
                );
                return;
            }

            this.blackPackageList = this.getBlackPackageNameList();
            this.whitePackageList = this.getWhitePackageNameList();

            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            BootstrapUtil.showModal(refObj.androidGooglePlayDialog.GetID());
        }

        /**
         * @brief	ブラックリストのパッケージ名を取得
         */
        private getBlackPackageNameList(): Set<string> {
            const blackPackageList = new Set<string>();
            this.blackListProhibitSetting.forEach(x => {
                blackPackageList.add(x.basicInfo.packageName.toLowerCase())
            });

            return blackPackageList;
        }

        /**
         * @brief	ホワイトリストのパッケージ名を取得
         */
        private getWhitePackageNameList(): Set<string> {
            const whitePackageList = new Set<string>();
            this.listWhiteSetting.forEach(x => {
                whitePackageList.add(x.basicInfo.packageName.toLowerCase())
            });

            return whitePackageList;
        }

        /**
         * @brief	削除ボタン（禁止するアプリケーション（ブラックリスト））
         */
        private onBtnDelProhibitApp(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const selectedIndex = refObj.prohibitList.getSelectListIndex();

            for (let i = selectedIndex.length; 0 < i; i--) {
                this.blackListProhibitSetting.splice(selectedIndex[i - 1], 1);
            }

            this.$emit("notifyUpdate");
        }

        /**
         * Google Play 選択ダイアログの [OK]ハンドラ
         */
        public onApplicationSelected(packageName: string, wrap: AndroidApplicationWrapper): void {
            // MDMアプリの場合は追加不可
            if (wrap.isMDMApp) {
                MessageUtil.MessageBox(
                    "「SKYSEA MDM」アプリは、「利用を禁止するアプリケーション（ブラックリスト）」に追加できません。"
                    , null
                    , null
                    , MessageUtil.MB_ICON_WARNING
                );
                return;
            }

            // UI表示用データクラスに格納する
            var selectedData = new AndroidAppMgrApplicationSetting();
            selectedData.basicInfo.appName = String(wrap.appData.title);
            selectedData.basicInfo.packageName = packageName;
            selectedData.policyJson.packageName = packageName;
            selectedData.basicInfo.appSettingType = AndroidAppDistDefinition.APP_SETTING_TYPE_GOOGLE_PLAY;
            
            // アイコン
            if (undefined != wrap.appData.smallIconUrl || null != wrap.appData.smallIconUrl) {
                selectedData.basicInfo.iconUrl = wrap.appData.smallIconUrl;
            }
            else {
                selectedData.basicInfo.iconUrl = "";
            }

            // 提供元
            if (undefined != wrap.appData.author || null != wrap.appData.author) {
                selectedData.basicInfo.author = wrap.appData.author;
            }
            else {
                selectedData.basicInfo.author = "";
            }

            // カテゴリ
            if (undefined != wrap.appData.category || null != wrap.appData.category) {
                selectedData.basicInfo.category = wrap.appData.category;
            }
            else {
                selectedData.basicInfo.category = "";
            }

            selectedData.basicInfo.updateTimeUtc = new Date();

            // 配布禁止固定
            this.converter.SetDistributionType(selectedData.policyJson, ApplicationPolicyDef.DISTRIBUTION_TYPE.Black);
            this.blackListProhibitSetting.push(selectedData);

            this.$emit("notifyUpdate");
        }
    } 
</script>

<style>
    /* アプリケーション管理部分のCSSはオンプレ版と共通を使用する */
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>